import { WF_BIZ_TYPES } from '../config/workflowConstants';

/** 与后端 workflowRegistryCheck.WF_BIZ_ADAPTER 保持一致 */
export const WF_BIZ_TO_ADAPTER = {
  onboarding: 'hr_process',
  regularization: 'hr_process',
  transfer: 'hr_process',
  resignation: 'hr_process',
  expense_daily: 'exp_claim',
  expense_prepayment_append: 'exp_claim',
  company_cert_change: 'adm_cert_change',
  company_cert_borrow: 'adm_cert_borrow',
  company_deregistration: 'adm_company_deregistration',
  contract_approval: 'adm_contract_approval',
  seal_other_approval: 'adm_seal_other_approval',
  plan_org_due_extension: 'plan_org_due_extension',
  severance_compensation: 'severance_compensation',
  overtime_apply: 'overtime_apply',
  outside_apply: 'outside_apply',
  business_trip_apply: 'business_trip_apply',
  makeup_apply: 'makeup_apply',
  leave_apply: 'leave_apply',
  budget_adjustment: 'budget_adjustment',
  fin_internal_fund_transfer: 'fin_internal_fund_transfer',
  fin_social_fund_payment: 'fin_social_fund_payment',
  hr_social_insurance_change: 'hr_social_insurance_change',
  exp_prepayment: 'exp_prepayment',
  exp_prepayment_writeoff: 'exp_prepayment_writeoff',
  exp_prepayment_adjust: 'exp_prepayment_adjust',
  regularization_delay: 'regularization_delay'
};

/** 与后端 workflowBizRegistry.CLAIM_WF_TYPE 保持一致 */
export const CLAIM_WF_TYPE = {
  daily: 'expense_daily',
  prepayment_append: 'expense_prepayment_append'
};

const HIDDEN_INITIATE = new Set(
  WF_BIZ_TYPES.filter((item) => item.hiddenInitiate).map((item) => item.value)
);

const INITIATE_BIZ_SET = new Set(WF_BIZ_TYPES.map((item) => item.value));

export function isCopyableInitiateBizType(wfBizType) {
  return Boolean(wfBizType && INITIATE_BIZ_SET.has(wfBizType) && !HIDDEN_INITIATE.has(wfBizType));
}

function listWfBizTypesForAdapter(adapterBizType) {
  return Object.entries(WF_BIZ_TO_ADAPTER)
    .filter(([, adapter]) => adapter === adapterBizType)
    .map(([wfBizType]) => wfBizType);
}

export function resolveInitiateBizType(storageBizType, process = {}) {
  if (!storageBizType) return null;

  let candidate = null;

  if (storageBizType === 'hr_process') {
    candidate = process.process_type || null;
  } else if (storageBizType === 'exp_claim') {
    const claimType = process.claim_type || process.process_type || 'daily';
    candidate = CLAIM_WF_TYPE[claimType] || 'expense_daily';
  } else {
    const processType = process.process_type || process.claim_type || null;
    if (processType && WF_BIZ_TO_ADAPTER[processType] === storageBizType) {
      candidate = processType;
    } else {
      const matches = listWfBizTypesForAdapter(storageBizType);
      if (matches.length === 1) {
        candidate = matches[0];
      } else if (processType && matches.includes(processType)) {
        candidate = processType;
      }
    }
  }

  if (!candidate || !isCopyableInitiateBizType(candidate)) return null;
  return candidate;
}
